import { SelectOptionProps } from '@acceso/design-system';

import { CHANNEL_MEDIA_TYPE_TO_ICON } from '@/features/broadcasters/constants/icons';

import { useChannels } from '../api/get-channels';
import { ChannelFilters } from '../types';

export function useChannelOptions(filters?: Partial<ChannelFilters>): SelectOptionProps<string>[] {
  const { data: { data: channels = [] } = {} } = useChannels({
    params: filters,
  });
  const options: SelectOptionProps<string>[] = channels.map(channel => ({
    label: channel.short_name ? `${channel.name} (${channel.short_name})` : channel.name,
    value: channel.id,
    icon: CHANNEL_MEDIA_TYPE_TO_ICON[channel.media_type],
  }));

  return options;
}
